import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { COLORS } from '@app/constants';
import { View, Text } from '@/styles/reactnative';
import { CButton } from '../Common';

const AuthCheckText = () => {
  const navigation = useNavigate();
  const { t } = useTranslation();
  return (
    <View
      style={{
        flexDirection: 'row',
        color: COLORS.greyWhite,
        marginTop: 70,
        marginBottom: 70,
        gap: 4,
      }}
    >
      <Text>{t('please')}</Text>
      <CButton
        title={t('login')}
        onClick={() => {
          navigation('/login');
        }}
        style={{ color: COLORS.primary }}
      />
      <Text>{t('or')}</Text>
      <CButton
        title={t('signUp')}
        onClick={() => {
          navigation('/signup');
        }}
        style={{ color: COLORS.primary }}
      />
    </View>
  );
};

export default AuthCheckText;
